import axios from "axios";

const apiUrl = import.meta.env.VITE_API_URL + "categories";

export const dynamic = "force-dynamic";

export class CategoryService {
  // Token handled by cookie

  // add a new category
  async addCategory(category) {
    try {
      const res = await axios.post(`${apiUrl}`, category, {
        withCredentials: true
      });
      const data = res.data;

      if (!data.success) {
        throw new Error(data);
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  // get all categories
  async getCategories() {
    try {
      const res = await axios.get(`${apiUrl}`, {
        withCredentials: true
      });

      const data = res.data;

      if (!data.success) {
        throw new Error(data);
      }
      return data;
    } catch (error) {
      throw error;
    }
  }

  // get a single category
  async getCategory(id) {
    try {
      const res = await axios.get(`${apiUrl}/${id}`, {
        withCredentials: true
      });
      const data = res.data;

      if (!data.success) {
        throw new Error(data);
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  // update a category
  async updateCategory({ id, ...rest }) {
    try {
      const res = await axios.put(`${apiUrl}/${id}`, rest, {
        withCredentials: true
      });
      const data = res.data;

      if (!data.success) {
        throw new Error(data);
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  // delete a category
  async deleteCategory(id) {
    try {
      const res = await axios.delete(`${apiUrl}/${id}`, {
        withCredentials: true
      });
      const data = res.data;

      if (!data.success) {
        throw new Error(data);
      }

      return data;
    } catch (error) {
      throw error;
    }
  }
}
